<div class="host-hostex-status v4-layout-content !px-0 !py-0 overflow-hidden">
  <host-multi-house-calendar
    #calendar
    class="host-calendar-body"
    [calendarType]="calendarType"
    [listOfHouses]="listOfHouses"
    [calendarMap]="calendarMap"
    [reservationMap]="reservationMap"
    [hourReservationMap]="hourReservationMap"
    [taskMap]="taskMap"
    [reservationStyle]="reservationStyle"
    [freeHouseCountMap]="freeHouseCountMap"
    [housesOversaleMap]="housesOversaleMap"
    [inventoryDiffMap]="inventoryDiffMap"
    [freeHouseCountMapByType]="freeHouseCountMapByType"
    [housesPriceMap]="housesPriceMap"
    [isInternational]="international"
    [displayLeadPrice]="displayLeadPrice"
    [displayLeadRules]="displayLeadRules"
    (onDatesChange)="onDatesChange($event)"
    (onClickChangeAvailable)="onClickChangeAvailable($event)"
    (onClickChangeTab)="onClickChangeTab($event)"
    (onClickSetHouseTypeInventory)="onClickSetHouseTypeInventory($event)"
    (onClickSaveEditNote)="onClickSaveEditNote($event)"
    (onClickUpdateCleanStatus)="onClickUpdateCleanStatus($event)"
    (onCalendarScrollToBottom)="displayPagination = $event"
    (onChangeOrderBelongedHouse)="onChangeOrderBelongedHouse($event)"
    (onClickExtendStay)="onClickExtendStay($event)"
    (onClickCreateTask)="onClickCreateTask($event)">
    <nz-pagination
      *ngIf="displayPagination && totalHouseCount > pageSize"
      [nzPageSize]="pageSize"
      [(nzPageIndex)]="currentPage"
      (nzPageIndexChange)="onPageChange()"
      [nzTotal]="totalHouseCount"></nz-pagination>

    <div class="filter-tpl flex flex-row items-center h-full px-[10px]" [formGroup]="filterForm">
      <v4-widget-input
        [showSearchIcon]="true"
        [placeholder]="'order.house_name' | translate"
        formControlName="title"></v4-widget-input>
      <i
        class="ml-2 cursor-pointer"
        nz-icon
        nzType="reload"
        nzTheme="outline"
        nz-tooltip
        [nzTooltipTitle]="'calendar-filter_html_sync_now' | translate"
        (click)="onSyncReservations()"></i>
    </div>

    <div class="empty-content">
      <div class="v4-layout-empty !pt-[80px]" *ngIf="couldRender && notCreateHouse">
        <img
          src="/assets/status/empty-placeholder.png"
          style="width: 300px; height: auto"
          alt=""
          class="v4-layout-empty-img !rounded-none" />
        <div class="v4-layout-empty-content">
          <div class="v4-layout-empty-content-title">{{ "empty_page.title.house2" | translate }}</div>
          <div class="v4-layout-empty-content-desc">{{ "empty_page.desc.house2" | translate }}</div>
        </div>
        <div class="v4-layout-empty-footer">
          <a [routerLink]="['/app/properties']">
            <button nz-button nzType="primary">
              <!-- 创建房间 -->
              {{ "empty_page.title.house1" | translate }}
            </button>
          </a>
        </div>
      </div>

      <div class="v4-layout-empty !pt-[80px]" *ngIf="couldRender && !notCreateHouse && listOfHouses.length === 0">
        <img
          class="v4-layout-empty-img !rounded-none"
          style="width: 300px; height: auto"
          src="/assets/calendar/empty.png" />
        <div class="v4-layout-empty-content">
          <div class="v4-layout-empty-content-title">
            {{ "calendar.empty_house.tip1" | translate }}
            <!-- 暂无房间/房型 -->
          </div>
          <div class="v4-layout-empty-content-desc" *ngIf="!searching">
            {{ "calendar.empty_house.tip2" | translate }}
            <!-- 请前往房间页面创建 -->
          </div>
        </div>
      </div>
    </div>
  </host-multi-house-calendar>

  <!-- <host-operate-sidebar
    *ngIf="selectStatus?.status === 'done' || type === 'hour-reservation'"
    [type]="type"
  ></host-operate-sidebar> -->

  <!-- <host-order-detail-sidebar></host-order-detail-sidebar> -->

  <host-draggable-operator
    widgetType="status"
    [widgetCount]="widgetCount"
    [displayLeadPrice]="displayLeadPrice"
    [displayLeadRules]="displayLeadRules"
    (onClickScroll)="scroll($event)"
    (onClickDeposit)="displayDepositModal()"
    (onClickWidget)="displayWidgetModal($any($event))"
    (onClickShare)="onClickShare($event)"
    (onToggleDisplayLeadPrice)="onToggleDisplayLeadView('price', $event)"
    (onToggleDisplayLeadRules)="onToggleDisplayLeadView('rules', $event)"></host-draggable-operator>

  <!-- <ng-template #icalModal>
    <div class="icalModal">
      <p class="body">
        {{ 'calendar.ical.content' | translate }}
        各渠道提供的iCal日历存在同步混乱的问题，请前往各官方渠道关闭iCal日历同步，避免影响房态正常开关。未开启iCal日历请忽略。
      </p>
      <div class="footer">
        <div class="left">
          <label [(ngModel)]="disableDisplayICal" for nz-checkbox>
            {{ 'word.no_longer_prompt_2' | translate }}
            不再提醒
          </label>
        </div>
        <div class="right">
          <button nz-button (click)="dismissICalModal()">
            {{ 'word.i_know' | translate }}
            我知道了
          </button>
          <button *ngIf="!international" nz-button nzType="primary" (click)="toBlogPage()">如何关闭</button>
        </div>
      </div>
    </div>
  </ng-template> -->

  <host-new-comer-promotion *ngIf="displayPromotion"></host-new-comer-promotion>
</div>

<!-- share calendar modal -->
<nz-modal
  [(nzVisible)]="displayShareSuccessModal"
  (nzOnOk)="displayShareSuccessModal = false"
  (nzOnCancel)="displayShareSuccessModal = false">
  <ng-container *nzModalContent>
    <div class="text-center">
      <span class="mb-[30px] text-[40px] text-[#faad14]" nz-icon nzType="check-circle" nzTheme="outline"></span>
      <div class="text-l">{{ "status-calendar_html_shared_success_title" | translate }}</div>
    </div>
  </ng-container>

  <div class="text-center" *nzModalFooter>
    <button nz-button nzType="default" (click)="displayShareSuccessModal = false; displayManageShareLinkModal()">
      {{ "status-calendar_html_shared_success_link" | translate }}
    </button>
    <button nz-button nzType="primary" (click)="displayShareSuccessModal = false">
      {{ "word.confirm" | translate }}
    </button>
  </div>
</nz-modal>
